const LogoDashboard = (props) => (
  <img
    alt="Logo"
    src="/static/logo.png"
    width="107px"
    height="20px"
    {...props}
  />
);

export default LogoDashboard;
